<template>
  <div class="diseaseList">
    <!-- 筛选查询框 @change="selectGoodsByIdBtn"-->
    <el-form :inline="true">
      <el-button type="primary" size="small" v-waves @click="handleAdd">新增</el-button>
      <el-button type="danger" size="small" v-waves @click="handleBatchDelete" :disabled="selectedRows.length === 0">批量删除</el-button>
      <el-button type="success" size="small" v-waves @click="handleBatchSend" :disabled="selectedRows.length === 0">批量发送通知</el-button>
      <!-- <span v-if="selectedRows.length > 0" style="margin-left: 10px; color: #409EFF;">已选择 {{ selectedRows.length }} 项</span> -->
      <el-form-item label="openid: " style="margin:0 20px" size="small">
        <el-input v-model="listQuery.openid" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="gzh_openid: " style="margin:0 20px" size="small">
        <el-input v-model="listQuery.gzh_openid" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="用户昵称: " style="margin:0 20px" size="small">
        <el-input v-model="listQuery.user_name" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="search" size="small" v-waves>搜索</el-button>
    </el-form>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        ref="elTable"
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <template slot="appid" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">
            {{
            arrayByIdToNameStr({
            ArrayData: gzhList,
            ID: row.appid,
            id_key:'appid',
            name_key:'account_name'
            })
            }}
          </el-tag>
        </template>
        <template slot="user_name" slot-scope="{ row }">{{row.user_name?row.user_name:'-'}}</template>
        <template slot="openid" slot-scope="{ row }">{{row.openid?row.openid:'-'}}</template>
        <template slot="gzh_img" slot-scope="{ row }">
          <el-image
            class="elImage"
            :src="row.gzh_img"
            :preview-src-list="[row.gzh_img]"
            v-if="row.gzh_img"
          ></el-image>
          <div v-else>暂未上传</div>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="handleEdit(row)" primary>编辑</el-button>
            <el-button size="mini" type="text" @click="handleSend(row)" primary>发送通知</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
            >删除</el-button>
            <el-button size="mini" type="text" @click="handleCopy(row)" primary>复制gzh_openid</el-button>
          </div>
        </template>
      </ElTable>

      <!-- 产品提交表单 -->
      <CommonDrawer
        :visible.sync="dialogFormVisible"
        :title="inpitTypeName"
        :close-on-click-modal="false"
        @confirm="save"
        @cancel="dialogFormVisible = false"
      >
        <el-form ref="form" :model="dialogForm" label-width="130px">
          <!-- <el-form-item label="公众号二维码">
            <el-input clearable v-model="dialogForm.gzh_img" placeholder="图片地址"></el-input>
            <el-upload
              name="formData"
              class="upload-demo"
              :action="action"
              :on-success="
              (response) => {
                return handleSuccess(response);
              }
            "
              multiple
              :limit="1"
              :file-list="fileList"
            >
              <el-button
                class="addBtn uploadPic"
                size="mini"
                type="primary"
                style="padding: 9px 5px"
              >上传图片</el-button>
              <div slot="tip">请上传jpg，png格式</div>
            </el-upload>
          </el-form-item>-->

          <el-form-item label="openid" required>
            <el-input v-model="dialogForm.openid" clearable></el-input>
          </el-form-item>
          <el-form-item label="gzh_openid" required>
            <el-input v-model="dialogForm.gzh_openid" clearable></el-input>
          </el-form-item>
          <el-form-item label="昵称" required>
            <el-input v-model="dialogForm.user_name" clearable></el-input>
          </el-form-item>
        </el-form>
      </CommonDrawer>

      <!-- 发送通知抽屉 -->
      <CommonDrawer
        :visible.sync="drawerVisible"
        :title="sendForm.isBatch ? `批量发送通知 (${selectedRows.length}个用户)` : '发送通知'"
        size="50%"
        :showFooter="false"
        @close="handleDrawerClose"
      >
        <el-form ref="sendForm" :model="sendForm" label-width="120px">
          <el-form-item label="gzh_openid" required v-if="!sendForm.isBatch">
            <el-input clearable v-model="sendForm.gzh_openid" disabled></el-input>
          </el-form-item>
          <el-form-item label="发送对象" v-if="sendForm.isBatch">
            <el-tag
              v-for="(row, index) in selectedRows"
              :key="index"
              type="success"
              size="small"
              style="margin: 5px"
            >
              {{ row.user_name || row.gzh_openid }}
            </el-tag>
          </el-form-item>
          <el-form-item label="选择模版ID" required>
            <el-select
              v-model="sendForm.template_id"
              placeholder="请选择"
              clearable
              style="width:100%"
              @change="changeTemplate"
            >
              <div v-for="(item, index) in templateList" :key="index">
                <el-option :label="item.name" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="模版内容" required v-if="sendForm.template_id">
            <div
              v-for="(item, index) in sendForm.template_msg_list"
              :key="index"
              style="display: flex;"
            >
              <el-tag type="success" size="mini" style="margin: 10px">字段中文描述:</el-tag>
              <el-input
                size="mini"
                v-model="item.keyName"
                placeholder="请输入"
                style="width: 200px; margin-right: 10px; margin-top: 5px"
                disabled
              ></el-input>

              <el-tag type="success" size="mini" style="margin: 10px">字段英文命名:</el-tag>
              <el-input
                size="mini"
                v-model="item.key"
                placeholder="请输入"
                style="width: 200px; margin-right: 10px; margin-top: 5px"
                disabled
              ></el-input>

              <el-tag type="success" size="mini" style="margin: 10px">字段默认值:</el-tag>
              <el-input
                size="mini"
                v-model="item.value"
                placeholder="请输入"
                style="width: 350px; margin-right: 10px; margin-top: 10px"
                type="textarea"
                :rows="1"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label>
            <el-button size="small" type="primary" @click="sendNotification" v-waves>发送</el-button>
          </el-form-item>
        </el-form>
      </CommonDrawer>
    </div>
  </div>
</template>
<script>
import {
  selectApi,
  updateApi,
  deleteApi,
  addApi
} from "@/services/sendService/sendUser";
import { selectApi as selectGzhListApi } from "@/services/sendService/sendAccount";
import { wxSendAPi } from "@/services/sendService/wxSend";
import { selectApi as selectTemplateApi } from "@/services/sendService/sendTemplate";
import ElTable from "@/components/elTable/index.vue";
import CommonDrawer from "@/components/drawer/index.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
export default {
  components: {
    ElTable,
    CommonDrawer
  },
  created() {
    this.getGzhList();
    this.getListData();
    this.getTemplateData();
  },

  data() {
    return {
      arrayByIdToNameStr,
      gzhList: [],
      loading: false,
      listQuery: {
        type: 1,
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },

      tableData: [],

      dialogFormVisible: false,
      inpitTypeName: "",
      fileList: [],

      dialogForm: {},

      // 发送通知相关
      drawerVisible: false,
      templateList: [],
      sendForm: {
        template_msg: [],
        template_msg_list: []
      },
      // 多选相关
      selectedRows: [], // 所有选中的行（跨分页）
      selectedRowIds: new Set() // 选中行的id集合（用于快速查找）
    };
  },
  computed: {
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },
  watch: {},
  methods: {
    async getGzhList() {
      const { data, code, count } = await selectGzhListApi({
        pageNumber: 1,
        pageSize: 100
      });
      if (code === 200) {
        this.gzhList = data;
      }
    },

    async getTemplateData() {
      const { data, code, count } = await selectTemplateApi({
        pageNumber: 1,
        pageSize: 1000
      });
      if (code === 200) {
        this.templateList = data.map(item => {
          return {
            ...item,
            name: item.template_name + "(模版ID:" + item.id + ")"
          };
        });
      }
    },

    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const { data, code, count } = await selectApi(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
          // 恢复当前页的选中状态
          this.$nextTick(() => {
            this.restoreSelection();
          });
        }, 600);
      }
    },
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    search() {
      this.listQuery.pageNumber = 1;
      // 搜索时清空选中项
      this.selectedRows = [];
      this.selectedRowIds = new Set();
      this.getListData();
    },
    handleAdd(type) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    handleSuccess(e) {
      console.log("handleSuccess", e);
      this.dialogForm.gzh_img = e.data;
      this.fileList = [];
      this.$message.success("上传成功，请继续操作");
    },
    /* 复制 */
    async handleCopy(row) {
      try {
        // 检查浏览器是否支持Clipboard API
        if (!navigator.clipboard) {
          this.$message.error("复制功能不支持");
          return;
        }

        // 复制gzh_openid到剪贴板
        await navigator.clipboard.writeText(row.gzh_openid);

        // 提示复制成功
        this.$message.success("复制成功");
      } catch (err) {
        // 处理复制失败的情况
        this.$message.error("复制失败");
        console.error("复制失败:", err);
      }
    },

    /* 保存 */
    save() {
      //必填字段校验
      if (
        !this.dialogForm.user_name ||
        !this.dialogForm.openid ||
        !this.dialogForm.gzh_openid
      ) {
        this.$message.error("请填写必填字段");
        return;
      }
      if (this.inpitTypeName == "新增") {
        addApi({ ...this.dialogForm }).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "新增成功!"
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
      if (this.inpitTypeName == "修改") {
        updateApi(this.dialogForm).then(resp => {
          console.log(resp);
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!"
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm(`此操作将永久删除'${row.user_name}'吗, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteApi({ id: row.id }).then(res => {
            console.log(res);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 发送通知 */
    handleSend(row) {
      this.drawerVisible = true;
      this.sendForm = {
        gzh_openid: row.gzh_openid,
        template_id: "",
        template_msg: [],
        template_msg_list: []
      };
    },

    /* 关闭抽屉 */
    handleDrawerClose() {
      this.sendForm = {
        template_msg: [],
        template_msg_list: []
      };
    },

    /* 选择模版 */
    changeTemplate(e) {
      console.log("e", e);
      const item = this.templateList.find(item => item.id == e);
      try {
        this.sendForm.template_msg_list = JSON.parse(item.template_msg_list);
      } catch (error) {
        this.sendForm.template_msg_list = [];
      }
    },

    /* 将数组转化为满足公众号模版格式的对象 */
    transformArrayToObject(array) {
      let transformed = {};
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const { key, value } = item;
        transformed[key] = { value };
      }
      return transformed;
    },

    /* 处理多选变化 */
    handleSelectionChange(selection) {
      // 移除当前页中未选中的项
      const currentPageIds = this.tableData.map(item => item.id);
      this.selectedRows = this.selectedRows.filter(
        item => !currentPageIds.includes(item.id)
      );
      this.selectedRowIds = new Set(this.selectedRows.map(item => item.id));

      // 添加当前页选中的项
      selection.forEach(item => {
        if (!this.selectedRowIds.has(item.id)) {
          this.selectedRows.push(item);
          this.selectedRowIds.add(item.id);
        }
      });
    },

    /* 恢复当前页的选中状态 */
    restoreSelection() {
      if (!this.$refs.elTable) return;
      const table = this.$refs.elTable.$children[0]; // 获取el-table实例
      if (!table) return;

      this.tableData.forEach(row => {
        if (this.selectedRowIds.has(row.id)) {
          table.toggleRowSelection(row, true);
        }
      });
    },

    /* 批量删除 */
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择要删除的项");
        return;
      }

      const names = this.selectedRows.map(row => row.user_name).join("、");
      this.$confirm(
        `此操作将永久删除选中的 ${this.selectedRows.length} 项(${names}), 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          // 批量删除
          const deletePromises = this.selectedRows.map(row =>
            deleteApi({ id: row.id })
          );

          try {
            await Promise.all(deletePromises);
            this.$message.success("批量删除成功!");
            // 清空选中项
            this.selectedRows = [];
            this.selectedRowIds = new Set();
            this.getListData();
          } catch (error) {
            this.$message.error("批量删除失败!");
          }
        })
        .catch(() => {});
    },

    /* 批量发送通知 */
    handleBatchSend() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择要发送通知的用户");
        return;
      }

      this.drawerVisible = true;
      // 批量发送时，使用第一个用户的gzh_openid作为示例，实际会给所有选中用户发送
      this.sendForm = {
        gzh_openid: this.selectedRows[0].gzh_openid,
        template_id: "",
        template_msg: [],
        template_msg_list: [],
        isBatch: true // 标记为批量发送
      };
    },

    /* 发送通知 */
    sendNotification() {
      let formData = JSON.parse(JSON.stringify(this.sendForm));
      for (let i = 0; i < formData.template_msg_list.length; i++) {
        const item = formData.template_msg_list[i];
        if (!item.keyName || !item.key || !item.value) {
          this.$message.error("请完善模版字段");
          return;
        }
      }
      try {
        formData.template_msg = this.transformArrayToObject(
          formData.template_msg_list
        );
      } catch (error) {
        formData.template_msg = null;
      }

      //必填字段校验
      if (
        !formData.template_id ||
        !formData.gzh_openid ||
        !formData.template_msg
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      delete formData.template_msg_list;
      
      // 判断是否为批量发送
      if (formData.isBatch) {
        // 批量发送通知
        const sendPromises = this.selectedRows.map(row => {
          const sendData = {
            ...formData,
            gzh_openid: row.gzh_openid
          };
          delete sendData.isBatch;
          return wxSendAPi(sendData);
        });

        Promise.all(sendPromises)
          .then(results => {
            const successCount = results.filter(res => res.code === 200).length;
            this.$message.success(
              `批量发送完成！成功 ${successCount}/${this.selectedRows.length} 条`
            );
            this.drawerVisible = false;
            // 清空选中项
            this.selectedRows = [];
            this.selectedRowIds = new Set();
          })
          .catch(error => {
            this.$message.error("批量发送失败");
          });
      } else {
        // 单个发送
        delete formData.isBatch;
        wxSendAPi(formData).then(res => {
          if (res.code == 200) {
            this.$message.success("发送成功");
            this.drawerVisible = false;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.diseaseList {
  width: 100%;
  padding: 20px;
}
.tableList {
  border-radius: 6px;
  background: #fff;
  /* max-width: 1405px; */
  margin: 10px auto;
}
.elImage {
  width: 60px;
  max-height: 60px;
  border-radius: 5px;
}
</style>
